export default __webpack_public_path__ + "static/media/spinner.bda511f8.gif";